<div
	class="d-flex lightbox position-fixed start-0 w-100 h-100 align-items-center justify-content-center"
	(click)="closeLightbox()"
	*ngIf="showLightbox">
	<div class="lightbox-content text-center p-3 p-md-4 p-xl-5" (click)="$event.stopPropagation()">
		<img alt="Expanded image" class="object-fit-fill rounded-4 shadow-lg" loading="lazy" [src]="imageSrc" />
	</div>
</div>